import React from 'react';
import PropTypes from 'prop-types';
import Form from '../form/form';
import { babyInputs } from '../../helpers/babyBookHelper';
import './Lightbox.css';


function getImage(activeImage, galleryImages, isNext) {
  const imageNumber = isNext ? activeImage + 1 : activeImage - 1;

  if (galleryImages[imageNumber]) {
    const showImage = galleryImages[imageNumber] ? galleryImages[imageNumber].thumbnailUrl : '';
    return {
      showImage,
      activeImage: imageNumber,
    };
  }

  return false;
}

function hasClass(e, className) {
  if (e) {
    return e.target.classList.contains(className);
  }
  return false;
}

class Lightbox extends React.Component {
  constructor(props) {
    super(props);

    const { galleryImages, imageIndex } = props;
    const showImage = galleryImages[imageIndex] ? galleryImages[imageIndex].thumbnailUrl : '';

    this.state = {
      opened: true,
      activeImage: imageIndex,
      showImage,
    };
  }

  setImage = (isNext = true) => {
    const { galleryImages } = this.props;
    const { activeImage } = this.state;

    return this.setState(() => (getImage(activeImage, galleryImages, isNext)));
  }


  closeLightBox = (e) => {
    if (this.props.isForm) {
      return false;
    }

    if (hasClass(e, 'lightbox-overLay') || hasClass(e, 'close')) {
      this.props.setLightBox();
      this.setState(prevState => ({
        opened: !prevState.opened,
      }));
    }
  }

  closeIcon = () => {
    const { lang } = this.props;
    return (
      <i
        className="fa fa-times close"
        onClick={e => this.closeLightBox(e)}
        onKeyDown={() => {}}
        role="presentation"
      >
        <span>{lang.close}</span>
      </i>
    );
  }

  renderHelpContent = (videoId, content) => (

    <div>
      { content && <p>{content}</p> }
      { videoId !== '' &&
      <div className="embed-container">
        <iframe
          title="embed"
          src={`//www.youtube.com/embed/${videoId}?showinfo=0&rel=0&autoplay=1`}
          frameBorder="0"
          allowFullScreen
        />
      </div>
      }
    </div>)

  renderHeading = () => {
    const { lang } = this.props;
    return (
      <div>
        <h2>{lang.title_notice}</h2>
        <h3>{lang.baby_form_notice}</h3>
      </div>
    );
  }

  render() {
    const {
      url,
      isForm,
      lang,
      texts,
      bookRatio,
      bookProps,
      dispatch,
      pageId,
      layoutHeight,
      bookHeight,
      videoLink,
      content,
      galleryImages,
    } = this.props;

    const {
      opened,
      showImage,
      activeImage,
    } = this.state;
    const isVideo = videoLink !== '' || content !== '';

    const isLastImage = galleryImages.length === (activeImage + 1);
    const isFirstImage = activeImage === 0;

    return (opened &&
      <div
        className="lightbox-overLay"
        onClick={e => this.closeLightBox(e)}
        onKeyDown={() => {}}
        role="presentation"
        >
        <div className={`lightboxContainer ${isForm ? 'formModal' : ''}`}>
          { isForm && this.renderHeading() }
          { !isForm && this.closeIcon() }
          { !isVideo && !isForm && !isLastImage && <i className="fa fa-angle-right pager" aria-hidden="true" onClick={() => this.setImage()} /> }
          { !isVideo && !isForm && <img src={showImage} alt="" />}
          { !isVideo && !isForm && !isFirstImage && <i className="fa fa-angle-left pager" aria-hidden="true" onClick={() => this.setImage(false)} /> }
          { isForm &&
            <Form
              inputs={babyInputs()}
              lang={lang}
              texts={texts}
              bookRatio={bookRatio}
              bookProps={bookProps}
              dispatch={dispatch}
              bookHeight={bookHeight}
              layoutHeight={layoutHeight}
              pageId={pageId}
              close={e => this.closeLightBox(e)}
            /> }

          { isVideo && this.renderHelpContent(videoLink, content) }
        </div>
      </div>
    );
  }
}

Lightbox.defaultProps = {
  url: '',
  setLightBox: () => {},
  isForm: false,
  lang: {},
  texts: {},
  bookProps: {},
  dispatch: () => {},
  pageId: 0,
  bookRatio: 1,
  layoutHeight: 0,
  bookHeight: 0,
  videoLink: '',
  content: '',
  galleryImages: [],
  imageIndex: 0,
};

Lightbox.propTypes = {
  url: PropTypes.string,
  setLightBox: PropTypes.func,
  isForm: PropTypes.bool,
  lang: PropTypes.object,
  texts: PropTypes.object,
  bookProps: PropTypes.object,
  dispatch: PropTypes.func,
  pageId: PropTypes.number,
  bookRatio: PropTypes.number,
  layoutHeight: PropTypes.number,
  bookHeight: PropTypes.number,
  videoLink: PropTypes.string,
  content: PropTypes.string,
  galleryImages: PropTypes.array,
  imageIndex: PropTypes.number,
};


export default (Lightbox);



// WEBPACK FOOTER //
// ./src/components/lightbox/Lightbox.jsx